const data = [
    {
      "title": "Classes exchanged",
      "details": "You changed your classes from one section to other. Make sure you sit in the lastest section you selected. Enjoy you new class Simit.!",
	  "category": "reminders",
      "id": 1
    },
    {
      "title": "Resume and Cover letter.",
      "details": "Need to update my resume with my current skills set and make a cover letter so that i get a job as soon as possible. Hopefully i will get one at the end of August.",
	  "category": "work",
      "id": 2
    },
    {
      "title": "Python learning practice",
      "details": "Practice python you learnt every day. Practice makes man perfect and you will surely succeed in this tech field because you have passion for it. After Python start python scripting and do some cool stuff.",
      "category": "todos",
      "id": 3
    },
	{
		"title": "Send rent and phone bill",
		"details": "I have to send phone bill and the next month rent to my brother in 15 days get ready.",
		"category": "money",
		"id": 4
	}
  ];


export default data;